import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import * as authActions from "store/actions/authActions";
import * as uiActions from "store/actions/uiActions";
import { importLangResources } from "locale";

const PASSWORD_WARNING_SNACKBAR_ID = "password-warning";

importLangResources(["generic", "header"]);

const getPasswordWarningTranslationKey = (code, remainingDay) => {
  if (remainingDay !== 0) {
    return code;
  }

  if (code === "in_grace_days") {
    return "in_grace_today";
  }

  return `${code}_today`;
};

const PasswordWarning = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const warning = useSelector(state => state.auth.passwordWarning);
  const { t } = useTranslation();

  useEffect(() => {
    if (!warning) {
      return;
    }

    let { code, remaining_day } = warning;
    code = code.toLowerCase();

    const translationKey = getPasswordWarningTranslationKey(
      code,
      remaining_day
    );
    const message = t(`generic:password_warning.${translationKey}`, {
      remaining_days: remaining_day
    });

    dispatch(
      uiActions.addSnackbar({
        id: PASSWORD_WARNING_SNACKBAR_ID,
        message,
        status: "warning",
        placement: "top-right",
        autoHide: false,
        actionButton: {
          title: t("header:buttons.settings"),
          func: () => {
            dispatch(uiActions.removeSnackbar(PASSWORD_WARNING_SNACKBAR_ID));
            navigate("/settings/general");
          }
        }
      })
    );
    dispatch(authActions.setPasswordWarning(false));
  }, [dispatch, navigate, t, warning]);

  return null;
};

export default PasswordWarning;
